var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContratB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0701 23.4143C94.9001 35.9843 136.71 48.5743 178.54 61.1343V233.944L53.0701 190.274V23.4143Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.07 54.9648C191.55 57.0348 185.04 59.0749 178.54 61.1349L53.0701 23.4149C60.4201 21.2749 67.7501 19.1149 75.1101 16.9749C116.1 29.6349 157.1 42.3048 198.07 54.9648Z",
    fill: "#72D09A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.07 54.9641V222.414L178.54 233.944V61.1341L198.07 54.9641Z",
    fill: "#29A063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.72 165.185C156.95 141.575 146.42 106.925 126.33 88.1649C106.24 69.4049 83.9302 73.1448 76.7802 96.4548C69.6202 119.765 80.1502 154.445 100.17 173.475C120.18 192.535 142.49 188.795 149.72 165.185Z",
    fill: "#FECECA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.35 162.035C152.92 140.615 143.38 109.135 125.13 92.0946C106.88 75.0546 86.6402 78.4446 80.1502 99.6246C73.6502 120.795 83.2203 152.255 101.37 169.565C119.54 186.825 139.78 183.465 146.35 162.045V162.035Z",
    fill: "#B2E8C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.45 158.404C123.73 158.424 124 158.354 124.24 158.204C124.91 157.814 125.13 156.974 124.73 156.334L108.16 128.864L109.54 99.2345C109.56 98.4745 108.97 97.8345 108.21 97.8045C107.45 97.7845 106.78 98.3445 106.76 99.1045L105.35 129.134C105.33 129.404 105.4 129.674 105.55 129.894L122.35 157.704C122.57 158.124 122.99 158.364 123.45 158.394V158.404Z",
    fill: "#FECECA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContratB);
export default __webpack_public_path__ + "static/media/contratB.4f3ad3e02ab515b78ac447178635c6b7.svg";
export { ForwardRef as ReactComponent };